import { baseApi } from "../baseApi";
import { DashboardResponse, TriggerResponsePayload } from "./type";

export const homeApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getDashboard: build.query<DashboardResponse, void>({
      query: () => ({
        url: "/youth/dashboard",
        method: "GET",
      }),
      providesTags: ["Dashboard"],
    }),
    triggerResponse: build.mutation<
      any,
      { entityId: string; body: TriggerResponsePayload }
    >({
      query: ({ entityId, body }) => ({
        url: `/youth/trigger-response/${entityId}`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["TriggerResponse"],
    }),
  }),
});

export const { useGetDashboardQuery, useTriggerResponseMutation } = homeApi;
